<template>
    <div>

 <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Equivalent Transfer Transcript</div>
          <div class="panal-body">
            <b-alert show><h4>Messege</h4>

You have passed Admission phase and you can Transferred</b-alert>

            <div class="clearfix"></div>


 
   
  
<span class="col-md-2">Choose another college</span>

 <b-form-select v-model="serial" class="mb-3 col-md-8">

      <b-form-select-option value="0"  selected>Please select one</b-form-select-option>
    <b-form-select-option v-for="Faculty in TransferredStu" :key="Faculty.serial" v-bind:value="Faculty.serial">
 {{Faculty.FacultyName_EN}}
      </b-form-select-option>
      <!-- <b-form-select-option :value="null">Please select an option</b-form-select-option>
      <b-form-select-option value="Faculty of Pharmacy">Faculty of Pharmacy</b-form-select-option>
      <b-form-select-option value="Faculty of Sciences">Faculty of Sciences</b-form-select-option>
      <b-form-select-option value="College of Veterinary Medicine">College of Veterinary Medicine </b-form-select-option>
      <b-form-select-option value="Faculty of agriculture">Faculty of agriculture</b-form-select-option> -->
    </b-form-select>
   <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>

 


    <!-- <div class="mt-2 col-md-6">Selected: <strong>{{ selected2 }}</strong></div> -->
    <div class="float-right m-3"> <b-button variant="success" v-on:click="getTranferList">View Equivalent Courses</b-button></div>

 <div class="clearfix"></div>


   


          </div>
        </div>
      </div>
    </div>


<div class="row" v-if="!isHidden">
<div class="col-md-12 mx-auto">
<div class="panal mt-20">
<div class="panal-header">Equivalent Courses</div> 
<div class="panal-body">


    <div class="table-responsive">
               <table class="table mt-3 table-bordered">
                <thead class="thead-light">
                  <tr>
                       <th scope="col">CourseName</th>
                    <th scope="col">CourseCode</th>
                    <th scope="col">CreditHours</th>
                
                   

                  </tr>
                </thead>
              
                <tbody v-if="empty" class="w-100">
                 <tr class="w-100">
                    <td colspan="3" class="w-100">No Data</td>
                  </tr>
                  </tbody>
                  <tbody v-else class="w-100">
                  <tr 
                    v-for="item in EquivalentTransfer" v-bind:Key="item.CourseSerial" class="w-100">
                   
                   
                <td>{{item.CourseNameEN}}</td>
                    <td>{{item.CourseCode}}</td>
                    <td >{{item.CreditHours}}</td>
                    
                  
  
                  </tr>
                  <tr class="text-center w-100 pt-5" v-if="EquivalentTransfer" >
                   <td colspan="3">
<b-button pill variant="outline-secondary mr-2 mt-3">Earned Hours ({{EquivalentTransfer[0].EarnedHours}})</b-button>
  <b-button pill variant="outline-secondary mt-3">Student Level ({{EquivalentTransfer[0].StudentLevel}})</b-button> 

</td>
</tr>  

                </tbody>

               
              </table>
</div>


 
<!-- <div class="text-center" v-else>
<b-button pill variant="outline-secondary mr-2">Earned Hours ()</b-button>
  <b-button pill variant="outline-secondary">Student Level ()</b-button> 


</div> -->


</div>
</div>
</div>
</div>



</div>
</template>



<script>
    import studentData from '../../services/student/studentDataServices';
    export default {
        name: 'TransferredStu',
        data(){
            return{
                TransferredStu: [],
                serial: null, 
                message:null,
                isLoading : true,
                selected2: null,
                show: true,
                isHidden: true,
                EquivalentTransfer:'',
                empty : true,
                successful : false,
            }
        }, computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },
       mounted(){
         //this.currenUser.StudentID  // 566
           studentData.GetStudentUniversityOtherFaculties(this.currenUser.StudentID).then(Response =>{
               this.isLoading = false ;
               this.TransferredStu = Response.data
                // eslint-disable-next-line no-console
                  // console.log('TransferredStu => ', Response.data)

           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.Message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            })
       },

       methods:{
         // get the list of equivilant 
         getTranferList(){
           this.isHidden = false                
                   //this.currenUser.StudentID this.serial
                   // Happy case is 787 , 10
                studentData.GetStudentEquivalentTransferTranscript(this.currenUser.StudentID,this.serial).then(Response =>{
               this.isLoading = false ;
               this.empty = false;
                this.successful = true;
               this.EquivalentTransfer = Response.data
                // eslint-disable-next-line no-console
                  // console.log('response data',Response.data)
                                 
           }, error => {
              this.empty = true;
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
              
this.successful = false
            })
         },
     onClick() {
      this.deleteClicked = true;
    },
        ok()
        {
         this.change = true;
        }
            }
       
       

    };
</script>











<style >
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #50BD77;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

.btn{
       border: 1px dashed;
}

</style>